import React from 'react'
import { makeStyles } from '@mui/styles'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '35px 25px',
    background: theme.backgroundColor,
  },
}))

const PanelFileContent = ({ children, className }) => {
  const classes = useStyles()
  return (
    <PerfectScrollbar
      className={clsx(classes.root, className)}
      options={{ scrollXMarginOffset: 10 }}
      component="div">
      {children}
    </PerfectScrollbar>
  )
}

export default PanelFileContent
